module.exports = __webpack_public_path__ + "img/about-values-integrity.jpg?c356ce8f0ea5af7023be437a4b4e273b";